import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { parseOAuthCallback, handleOAuthCallback } from '../utils/oauthConfig';
import api from '../api';
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../constants';
import LoadingIndicator from '../components/LoadingIndicator';
import '../styles/OAuthCallback.css';

function OAuthCallback() {
    const { provider } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [status, setStatus] = useState('Processing authentication...');

    useEffect(() => {
        const handleCallback = async () => {
            try {
                // Parse the OAuth callback parameters
                const { accessToken, error: oauthError, errorDescription } = parseOAuthCallback();

                console.log('[OAuth Callback] Provider:', provider);
                console.log('[OAuth Callback] Has access token:', !!accessToken);
                console.log('[OAuth Callback] OAuth error:', oauthError);
                console.log('[OAuth Callback] Current URL:', window.location.href);
                console.log('[OAuth Callback] Hash:', window.location.hash);

                if (oauthError) {
                    console.error('[OAuth Callback] OAuth error:', oauthError, errorDescription);
                    setError(errorDescription || 'Authentication failed');
                    setStatus('Authentication failed');
                    setTimeout(() => navigate('/login'), 3000);
                    return;
                }

                if (!accessToken) {
                    console.error('[OAuth Callback] No access token in URL');
                    setError('No access token received from provider');
                    setStatus('Authentication failed');
                    setTimeout(() => navigate('/login'), 3000);
                    return;
                }

                setStatus('Verifying with server...');
                console.log('[OAuth Callback] Sending token to backend...');

                // Authenticate with backend
                const response = await handleOAuthCallback(provider, accessToken, api);

                console.log('[OAuth Callback] Backend response:', response);

                if (response.access && response.refresh) {
                    // Store JWT tokens
                    localStorage.setItem(ACCESS_TOKEN, response.access);
                    localStorage.setItem(REFRESH_TOKEN, response.refresh);

                    console.log('[OAuth Callback] Tokens stored successfully');
                    setStatus('Authentication successful! Redirecting...');

                    // Redirect to the original path or chat page
                    const redirectPath = sessionStorage.getItem('oauth_redirect_path') || '/chat';
                    sessionStorage.removeItem('oauth_redirect_path');

                    console.log('[OAuth Callback] Redirecting to:', redirectPath);

                    setTimeout(() => {
                        navigate(redirectPath);
                    }, 1000);
                } else {
                    console.error('[OAuth Callback] Invalid response structure:', response);
                    setError('Invalid response from server');
                    setStatus('Authentication failed');
                    setTimeout(() => navigate('/login'), 3000);
                }
            } catch (err) {
                console.error('[OAuth Callback] Error:', err);
                console.error('[OAuth Callback] Error response:', err.response);
                console.error('[OAuth Callback] Error data:', err.response?.data);
                setError(err.response?.data?.error || err.message || 'Authentication failed. Please try again.');
                setStatus('Authentication failed');
                setTimeout(() => navigate('/login'), 3000);
            }
        };

        handleCallback();
    }, [provider, navigate]);

    return (
        <div className="oauth-callback-container">
            <div className="oauth-callback-card">
                <LoadingIndicator />
                <h2 className="oauth-callback-title">{status}</h2>
                {error && (
                    <div className="oauth-callback-error">
                        <p>{error}</p>
                        <p className="oauth-callback-redirect">Redirecting to login...</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default OAuthCallback;

